module.exports = __webpack_public_path__ + "images/marketing/redundant_backups.png";